/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export interface MerchantStatusAndDeactivatedDate {
  status: string;
  deactivatedDate: Date;
}
